import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { Select } from '../components/ui/Select';
import { DatePicker } from '../components/ui/DatePicker';
import { StatCard } from '../components/ui/StatCard';
import { Modal } from '../components/ui/Modal';
import { Input } from '../components/ui/Input';
import { ColumnCustomizer } from '../components/ColumnCustomizer';
import { WorkloadCard } from '../components/operations/WorkloadCard';
import { ActivityDetailModal } from '../components/operations/ActivityDetailModal';
import { OperativeActivity, operativeActivitiesStore } from '../services/operativeActivities';
import { useNavigate } from 'react-router-dom';
import { TrendingUp, Users, AlertCircle, Clock, CheckCircle2, Receipt, Calendar, Download, Target, FileText, PieChart, Euro, Plus, Edit, Trash2, Eye } from 'lucide-react';
import { LineChart, Line, BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart as RechartsPieChart, Pie, Cell, AreaChart, Area, ComposedChart } from 'recharts';
type TabType = 'operativa' | 'commerciale' | 'economica' | 'obiettivi';
// Mock Data for Charts
const trendData = [{
  name: 'Gen',
  offerte: 40000,
  positivi: 24000
}, {
  name: 'Feb',
  offerte: 30000,
  positivi: 13980
}, {
  name: 'Mar',
  offerte: 20000,
  positivi: 9800
}, {
  name: 'Apr',
  offerte: 27800,
  positivi: 3908
}, {
  name: 'Mag',
  offerte: 18900,
  positivi: 4800
}, {
  name: 'Giu',
  offerte: 23900,
  positivi: 3800
}];
const salesRepData = [{
  name: 'Alessio',
  positivi: 12000,
  target: 10000
}, {
  name: 'Lorenzo',
  positivi: 15000,
  target: 12000
}, {
  name: 'Gian Franco',
  positivi: 8000,
  target: 10000
}, {
  name: 'Tiziano',
  positivi: 9500,
  target: 9000
}];
const conversionData = [{
  name: 'Positivi',
  value: 29
}, {
  name: 'Negativi',
  value: 7
}, {
  name: 'In valutazione',
  value: 9
}];
const COLORS = ['#10B981', '#EF4444', '#F59E0B'];
const revenueData = [{
  name: 'Gen',
  fatturato: 45000,
  proformato: 12000,
  target: 50000
}, {
  name: 'Feb',
  fatturato: 52000,
  proformato: 8000,
  target: 50000
}, {
  name: 'Mar',
  fatturato: 48000,
  proformato: 15000,
  target: 50000
}, {
  name: 'Apr',
  fatturato: 61000,
  proformato: 5000,
  target: 55000
}, {
  name: 'Mag',
  fatturato: 55000,
  proformato: 10000,
  target: 55000
}, {
  name: 'Giu',
  fatturato: 59000,
  proformato: 12000,
  target: 60000
}];
const objectivesData = [{
  id: 1,
  month: 'Gennaio',
  targetSales: 10000,
  actualSales: 12500,
  targetRevenue: 40000,
  actualRevenue: 38000
}, {
  id: 2,
  month: 'Febbraio',
  targetSales: 10000,
  actualSales: 9800,
  targetRevenue: 40000,
  actualRevenue: 41200
}, {
  id: 3,
  month: 'Marzo',
  targetSales: 12000,
  actualSales: 15000,
  targetRevenue: 45000,
  actualRevenue: 48000
}, {
  id: 4,
  month: 'Aprile',
  targetSales: 12000,
  actualSales: 11000,
  targetRevenue: 45000,
  actualRevenue: 42000
}, {
  id: 5,
  month: 'Maggio',
  targetSales: 15000,
  actualSales: 18000,
  targetRevenue: 50000,
  actualRevenue: 52000
}, {
  id: 6,
  month: 'Giugno',
  targetSales: 15000,
  actualSales: 16500,
  targetRevenue: 50000,
  actualRevenue: 51000
}];
const topClientsData = [{
  name: 'Metalmeccanica Rossi SRL',
  amount: '€ 25.400',
  perc: '8.5%'
}, {
  name: 'Edilizia Moderna SPA',
  amount: '€ 18.200',
  perc: '6.1%'
}, {
  name: 'Supermercati Market',
  amount: '€ 15.100',
  perc: '5.0%'
}, {
  name: 'Ristorante Da Mario',
  amount: '€ 12.800',
  perc: '4.2%'
}, {
  name: 'Studio Legale Bianchi',
  amount: '€ 9.500',
  perc: '3.1%'
}, {
  name: 'Autofficina Veloce',
  amount: '€ 8.200',
  perc: '2.7%'
}, {
  name: 'Bar Centrale',
  amount: '€ 7.100',
  perc: '2.4%'
}, {
  name: 'Farmacia Salute',
  amount: '€ 6.800',
  perc: '2.3%'
}, {
  name: 'Hotel Bellavista',
  amount: '€ 5.900',
  perc: '2.0%'
}, {
  name: 'Panificio Dolce',
  amount: '€ 4.500',
  perc: '1.5%'
}];
const allActivities = [{
  user: 'Alessio',
  action: 'ha creato un nuovo contratto',
  target: 'Metalmeccanica Rossi SRL',
  date: '2 ore fa',
  icon: CheckCircle2,
  bg: 'bg-green-100',
  text: 'text-green-600'
}, {
  user: 'Lorenzo',
  action: 'ha completato il sopralluogo',
  target: 'Ristorante Da Mario',
  date: '4 ore fa',
  icon: CheckCircle2,
  bg: 'bg-blue-100',
  text: 'text-blue-600'
}, {
  user: 'Tiziano',
  action: 'ha segnalato una non conformità',
  target: 'Edilizia Moderna',
  date: 'Ieri',
  icon: AlertCircle,
  bg: 'bg-red-100',
  text: 'text-red-600'
}, {
  user: 'Amministrazione',
  action: 'ha emesso fattura #2024/45',
  target: 'Studio Legale Bianchi',
  date: 'Ieri',
  icon: Receipt,
  bg: 'bg-yellow-100',
  text: 'text-yellow-600'
}, {
  user: 'Gian Franco',
  action: 'ha aggiornato il DVR',
  target: 'Supermercati Market',
  date: '2 giorni fa',
  icon: FileText,
  bg: 'bg-purple-100',
  text: 'text-purple-600'
}, {
  user: 'Alessio',
  action: 'ha pianificato corso formazione',
  target: 'Hotel Bellavista',
  date: '3 giorni fa',
  icon: Calendar,
  bg: 'bg-indigo-100',
  text: 'text-indigo-600'
}];
const deadlinesData = [{
  id: 1,
  title: 'Rinnovo DVR',
  client: 'Autofficina Veloce',
  date: 'Domani',
  priority: 'high'
}, {
  id: 2,
  title: 'Corso antincendio',
  client: 'Supermercato Market',
  date: '15/05/2024',
  priority: 'medium'
}, {
  id: 3,
  title: 'Visita medica Rossi Mario',
  client: 'Edilizia Moderna',
  date: '16/05/2024',
  priority: 'medium'
}, {
  id: 4,
  title: 'Scadenza fattura #44',
  client: 'Bar Centrale',
  date: '18/05/2024',
  priority: 'low'
}];
const columnsConfig = [{
  key: 'month',
  label: 'Mese'
}, {
  key: 'targetSales',
  label: 'Obiettivo\nofferte'
}, {
  key: 'actualSales',
  label: 'Reale\nofferte'
}, {
  key: 'diffSales',
  label: 'Differenza\nofferte'
}, {
  key: 'targetRevenue',
  label: 'Obiettivo\nfatturato'
}, {
  key: 'actualRevenue',
  label: 'Reale\nfatturato'
}, {
  key: 'diffRevenue',
  label: 'Differenza\nfatturato'
}];
export function Dashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabType>('operativa');
  const [period, setPeriod] = useState('month');
  const [customStart, setCustomStart] = useState('');
  const [customEnd, setCustomEnd] = useState('');
  const [showActivitiesModal, setShowActivitiesModal] = useState(false);
  const [showTopClientsModal, setShowTopClientsModal] = useState(false);
  const [showObjectivesModal, setShowObjectivesModal] = useState(false);
  const [showDeadlineViewModal, setShowDeadlineViewModal] = useState(false);
  const [showDeadlineEditModal, setShowDeadlineEditModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedDeadline, setSelectedDeadline] = useState<any>(null);
  const [visibleColumns, setVisibleColumns] = useState(columnsConfig.map(c => c.key));
  const [objectivePeriodType, setObjectivePeriodType] = useState<'monthly' | 'annual'>('monthly');
  // Activity detail modal state
  const [selectedActivity, setSelectedActivity] = useState<OperativeActivity | null>(null);
  const [showActivityDetail, setShowActivityDetail] = useState(false);
  const userName = 'Alessio';
  const tabs = [{
    id: 'operativa' as TabType,
    label: 'Operativa'
  }, {
    id: 'commerciale' as TabType,
    label: 'Commerciale'
  }, {
    id: 'economica' as TabType,
    label: 'Economica'
  }, {
    id: 'obiettivi' as TabType,
    label: 'Obiettivi'
  }];
  const formatCurrency = (val: number) => `€ ${val.toLocaleString('it-IT')}`;
  const handleDeadlineClick = (item: any) => {
    setSelectedDeadline(item);
    setShowDeadlineViewModal(true);
  };
  const handleDeadlineEdit = (item: any, e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedDeadline(item);
    setShowDeadlineEditModal(true);
  };
  const handleDeadlineDelete = (item: any, e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedDeadline(item);
    setShowDeleteConfirm(true);
  };
  const handleViewActivity = (activity: OperativeActivity) => {
    setSelectedActivity(activity);
    setShowActivityDetail(true);
  };
  const handleEditActivity = (activity: OperativeActivity) => {
    navigate('/operations', {
      state: {
        editActivityId: activity.id
      }
    });
  };
  const handleStepComplete = (activityId: string, stepIndex: number) => {
    operativeActivitiesStore.completeStep(activityId, stepIndex);
    const updated = operativeActivitiesStore.getById(activityId);
    if (updated) {
      setSelectedActivity(updated);
    }
  };
  const renderOperativa = () => <>
      {/* KPI Cards - Static */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 mb-8" data-id="element-3077">
        {[{
        name: 'Fatturato mensile',
        value: '€ 45.231',
        change: '+12%',
        changeType: 'positive',
        icon: TrendingUp,
        color: 'bg-blue-500'
      }, {
        name: 'Clienti attivi',
        value: '124',
        change: '+4',
        changeType: 'positive',
        icon: Users,
        color: 'bg-green-500'
      }, {
        name: 'Fatture in scadenza',
        value: '8',
        change: '€ 12.400',
        changeType: 'negative',
        icon: AlertCircle,
        color: 'bg-red-500'
      }, {
        name: 'Scadenze settimana',
        value: '15',
        change: 'Urgenti: 3',
        changeType: 'neutral',
        icon: Clock,
        color: 'bg-seform-orange'
      }].map(kpi => <div key={kpi.name} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 relative overflow-hidden group" data-id="element-3078">
            <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-white/0 to-slate-50 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-110" data-id="element-3079"></div>
            <div className="relative z-10" data-id="element-3080">
              <div className="flex justify-between items-start mb-4" data-id="element-3081">
                <div className={`p-3 rounded-xl ${kpi.color} bg-opacity-10`} data-id="element-3082">
                  <kpi.icon className={`h-6 w-6 ${kpi.name === 'Scadenze settimana' ? 'text-seform-orange' : ''} ${kpi.name === 'Fatturato mensile' ? 'text-blue-600' : ''} ${kpi.name === 'Clienti attivi' ? 'text-green-600' : ''} ${kpi.name === 'Fatture in scadenza' ? 'text-red-600' : ''}`} data-id="element-3083" />
                </div>
                <Badge variant={kpi.changeType === 'positive' ? 'success' : kpi.changeType === 'negative' ? 'danger' : 'neutral'} size="sm" data-id="element-3084">
                  {kpi.change}
                </Badge>
              </div>
              <h3 className="text-slate-500 text-sm font-medium" data-id="element-3085">{kpi.name}</h3>
              <p className="text-2xl font-bold text-seform-navy mt-1" data-id="element-3086">
                {kpi.value}
              </p>
            </div>
          </div>)}
      </div>

      {/* Carico di lavoro - Full width above activity/deadlines */}
      <div className="mb-8" data-id="element-3087">
        <WorkloadCard data-id="element-3088" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-3089">
        {/* Recent Activity */}
        <Card title="Attività recenti" description="Ultime operazioni registrate nel sistema" actions={<Button variant="light" size="sm" onClick={() => setShowActivitiesModal(true)} data-id="element-3091">
              Vedi tutte
            </Button>} data-id="element-3090">
          <div className="flow-root" data-id="element-3092">
            <ul className="-mb-8" data-id="element-3093">
              {allActivities.slice(0, 4).map((activity, activityIdx) => <li key={activityIdx} data-id="element-3094">
                  <div className="relative pb-8" data-id="element-3095">
                    {activityIdx !== 3 && <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-slate-100" aria-hidden="true" data-id="element-3096" />}
                    <div className="relative flex space-x-3" data-id="element-3097">
                      <div data-id="element-3098">
                        <span className={`h-8 w-8 rounded-full flex items-center justify-center ring-4 ring-white ${activity.bg}`} data-id="element-3099">
                          <activity.icon className={`h-4 w-4 ${activity.text}`} aria-hidden="true" data-id="element-3100" />
                        </span>
                      </div>
                      <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" data-id="element-3101">
                        <div data-id="element-3102">
                          <p className="text-sm text-slate-500" data-id="element-3103">
                            <span className="font-semibold text-seform-navy" data-id="element-3104">
                              {activity.user}
                            </span>{' '}
                            {activity.action}{' '}
                            <span className="font-semibold text-seform-navy" data-id="element-3105">
                              {activity.target}
                            </span>
                          </p>
                        </div>
                        <div className="text-right text-xs whitespace-nowrap text-slate-400" data-id="element-3106">
                          {activity.date}
                        </div>
                      </div>
                    </div>
                  </div>
                </li>)}
            </ul>
          </div>
        </Card>

        {/* Upcoming Deadlines */}
        <Card title="Scadenze imminenti" description="Attività da completare nei prossimi 7 giorni" actions={<Button variant="light" size="sm" onClick={() => navigate('/deadlines')} data-id="element-3108">
              Vedi calendario
            </Button>} data-id="element-3107">
          <div className="space-y-3" data-id="element-3109">
            {deadlinesData.map(item => <div key={item.id} onClick={() => handleDeadlineClick(item)} className="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-100 hover:bg-white hover:shadow-sm transition-all cursor-pointer group" data-id="element-3110">
                <div className="flex items-center gap-3" data-id="element-3111">
                  <div className={`w-2 h-2 rounded-full ${item.priority === 'high' ? 'bg-red-500' : item.priority === 'medium' ? 'bg-yellow-500' : 'bg-blue-500'}`} data-id="element-3112"></div>
                  <div data-id="element-3113">
                    <h4 className="text-sm font-semibold text-seform-navy group-hover:text-seform-orange transition-colors" data-id="element-3114">
                      {item.title}
                    </h4>
                    <p className="text-xs text-slate-500" data-id="element-3115">{item.client}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-3116">
                  <span className="text-xs font-medium text-slate-500 bg-white px-2 py-1 rounded-md border border-slate-100" data-id="element-3117">
                    {item.date}
                  </span>
                  <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-3118">
                    <button onClick={e => handleDeadlineEdit(item, e)} className="p-1.5 rounded-md hover:bg-slate-100 transition-colors" title="Modifica scadenza" data-id="element-3119">
                      <Edit className="h-4 w-4 text-slate-400 hover:text-slate-600" data-id="element-3120" />
                    </button>
                    <button onClick={e => handleDeadlineDelete(item, e)} className="p-1.5 rounded-md hover:bg-slate-100 transition-colors" title="Elimina scadenza" data-id="element-3121">
                      <Trash2 className="h-4 w-4 text-slate-400 hover:text-red-500" data-id="element-3122" />
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
        </Card>
      </div>
    </>;
  const renderCommerciale = () => <>
      {/* Period Filter */}
      <div className="flex flex-wrap gap-3 items-end mb-8" data-id="element-3123">
        <div className="w-40" data-id="element-3124">
          <Select options={[{
          value: 'month',
          label: 'Mese corrente'
        }, {
          value: 'year',
          label: 'Anno corrente'
        }, {
          value: 'custom',
          label: 'Personalizzato'
        }]} value={period} onChange={e => setPeriod(e.target.value)} data-id="element-3125" />
        </div>
        {period === 'custom' && <div className="flex gap-2" data-id="element-3126">
            <DatePicker value={customStart} onChange={e => setCustomStart(e.target.value)} data-id="element-3127" />
            <DatePicker value={customEnd} onChange={e => setCustomEnd(e.target.value)} data-id="element-3128" />
          </div>}
        <Button variant="flat" color="secondary" startContent={<Download className="h-4 w-4" data-id="element-3130" />} data-id="element-3129">
          Esporta report
        </Button>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-3131">
        <StatCard title="Obiettivo offerte positive" value="€ 12.500" change="+25% vs Target" trend="up" icon={Target} color="bg-green-500" isStatic data-id="element-3132" />
        <StatCard title="Totale offerte" value="€ 45.200" change="15 Offerte" trend="neutral" icon={FileText} color="bg-blue-500" isStatic data-id="element-3133" />
        <StatCard title="Tasso conversione" value="65%" change="+5% vs Mese sc." trend="up" icon={TrendingUp} color="bg-seform-orange" isStatic data-id="element-3134" />
        <StatCard title="Media mensile positivi" value="€ 13.800" change="6 mesi" trend="neutral" icon={PieChart} color="bg-yellow-500" isStatic data-id="element-3135" />
      </div>

      {/* Charts */}
      <div className="space-y-8" data-id="element-3136">
        <Card title="Stato offerte" noHoverShadow data-id="element-3137">
          <div className="h-[280px] w-full relative" data-id="element-3138">
            <ResponsiveContainer width="100%" height="100%" data-id="element-3139">
              <RechartsPieChart data-id="element-3140">
                <Pie data={conversionData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-3141">
                  {conversionData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} style={{
                  outline: 'none'
                }} data-id="element-3142" />)}
                </Pie>
                <Tooltip wrapperStyle={{
                zIndex: 100
              }} data-id="element-3143" />
                <Legend verticalAlign="bottom" height={50} wrapperStyle={{
                paddingTop: '20px'
              }} data-id="element-3144" />
              </RechartsPieChart>
            </ResponsiveContainer>
            <div className="absolute top-[50%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center pointer-events-none flex flex-col items-center justify-center" data-id="element-3145">
              <p className="text-3xl font-bold text-seform-navy leading-none" data-id="element-3146">
                45
              </p>
              <p className="text-xs text-slate-500 mt-1" data-id="element-3147">Totali</p>
            </div>
          </div>
          <div className="mt-4 space-y-3" data-id="element-3148">
            <div className="flex justify-between items-center p-2 bg-green-50 rounded-lg" data-id="element-3149">
              <span className="text-sm font-medium text-green-700" data-id="element-3150">
                Positivi
              </span>
              <span className="font-bold text-green-700" data-id="element-3151">€ 24.500</span>
            </div>
            <div className="flex justify-between items-center p-2 bg-yellow-50 rounded-lg relative z-10" data-id="element-3152">
              <span className="text-sm font-medium text-yellow-700" data-id="element-3153">
                In valutazione
              </span>
              <span className="font-bold text-yellow-700" data-id="element-3154">€ 12.200</span>
            </div>
            <div className="flex justify-between items-center p-2 bg-red-50 rounded-lg relative z-10" data-id="element-3155">
              <span className="text-sm font-medium text-red-700" data-id="element-3156">Negativi</span>
              <span className="font-bold text-red-700" data-id="element-3157">€ 8.500</span>
            </div>
          </div>
        </Card>

        <div className="h-px bg-slate-200" data-id="element-3158"></div>

        <Card title="Trend offerte vs positive" className="min-h-[400px]" noHoverShadow data-id="element-3159">
          <div className="h-[300px] w-full mt-6" data-id="element-3160">
            <ResponsiveContainer width="100%" height="100%" data-id="element-3161">
              <LineChart data={trendData} data-id="element-3162">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-3163" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} dy={20} data-id="element-3164" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} data-id="element-3165" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-3166" />
                <Legend wrapperStyle={{
                paddingTop: '40px'
              }} data-id="element-3167" />
                <Line type="monotone" dataKey="offerte" stroke="#94A3B8" strokeWidth={2} dot={false} name="Totale offerte" data-id="element-3168" />
                <Line type="monotone" dataKey="positivi" stroke="#FF9500" strokeWidth={2} activeDot={{
                r: 8
              }} name="Positivi" data-id="element-3169" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Card>

        <div className="h-px bg-slate-200" data-id="element-3170"></div>

        <Card title="Performance per commerciale" className="min-h-[400px]" noHoverShadow data-id="element-3171">
          <div className="h-[300px] w-full mt-6" data-id="element-3172">
            <ResponsiveContainer width="100%" height="100%" data-id="element-3173">
              <RechartsBarChart data={salesRepData} layout="vertical" data-id="element-3174">
                <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#E2E8F0" data-id="element-3175" />
                <XAxis type="number" axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} data-id="element-3176" />
                <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} width={100} data-id="element-3177" />
                <Tooltip cursor={{
                fill: '#F1F5F9'
              }} data-id="element-3178" />
                <Legend wrapperStyle={{
                paddingTop: '20px'
              }} data-id="element-3179" />
                <Bar dataKey="positivi" fill="#FF9500" radius={[0, 4, 4, 0]} name="Positivi (€)" barSize={20} data-id="element-3180" />
                <Bar dataKey="target" fill="#CBD5E1" radius={[0, 4, 4, 0]} name="Target (€)" barSize={20} data-id="element-3181" />
              </RechartsBarChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>
    </>;
  const renderEconomica = () => <>
      {/* Period Filter */}
      <div className="flex flex-wrap gap-3 items-end mb-8" data-id="element-3182">
        <div className="w-40" data-id="element-3183">
          <Select options={[{
          value: 'month',
          label: 'Mese corrente'
        }, {
          value: 'year',
          label: 'Anno corrente'
        }, {
          value: 'custom',
          label: 'Personalizzato'
        }]} value={period} onChange={e => setPeriod(e.target.value)} data-id="element-3184" />
        </div>
        {period === 'custom' && <div className="flex gap-2" data-id="element-3185">
            <DatePicker value={customStart} onChange={e => setCustomStart(e.target.value)} data-id="element-3186" />
            <DatePicker value={customEnd} onChange={e => setCustomEnd(e.target.value)} data-id="element-3187" />
          </div>}
        <Button variant="flat" color="secondary" startContent={<Download className="h-4 w-4" data-id="element-3189" />} data-id="element-3188">
          Esporta report
        </Button>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-3190">
        <StatCard title="Fatturato emesso" value="€ 59.000" change="+8% vs Mese sc." trend="up" icon={Euro} color="bg-seform-navy" isStatic data-id="element-3191" />
        <StatCard title="Proformato" value="€ 12.000" change="5 Proforme" trend="neutral" icon={Receipt} color="bg-blue-500" isStatic data-id="element-3192" />
        <StatCard title="Totale produzione" value="€ 71.000" change="118% del Target" trend="up" icon={TrendingUp} color="bg-green-500" isStatic data-id="element-3193" />
        <StatCard title="Da incassare" value="€ 24.500" change="3 Scadute" trend="down" icon={AlertCircle} color="bg-red-500" isStatic data-id="element-3194" />
      </div>

      {/* Main Chart */}
      <Card title="Andamento fatturato vs target" className="mb-8 min-h-[450px]" noHoverShadow data-id="element-3195">
        <div className="h-[350px] w-full mt-6" data-id="element-3196">
          <ResponsiveContainer width="100%" height="100%" data-id="element-3197">
            <AreaChart data={revenueData} data-id="element-3198">
              <defs data-id="element-3199">
                <linearGradient id="colorFatturato" x1="0" y1="0" x2="0" y2="1" data-id="element-3200">
                  <stop offset="5%" stopColor="#2D1B69" stopOpacity={0.8} data-id="element-3201" />
                  <stop offset="95%" stopColor="#2D1B69" stopOpacity={0} data-id="element-3202" />
                </linearGradient>
                <linearGradient id="colorProformato" x1="0" y1="0" x2="0" y2="1" data-id="element-3203">
                  <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.8} data-id="element-3204" />
                  <stop offset="95%" stopColor="#3B82F6" stopOpacity={0} data-id="element-3205" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-3206" />
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
              fill: '#64748B'
            }} dy={20} data-id="element-3207" />
              <YAxis axisLine={false} tickLine={false} tick={{
              fill: '#64748B'
            }} data-id="element-3208" />
              <Tooltip contentStyle={{
              borderRadius: '8px',
              border: 'none',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} data-id="element-3209" />
              <Legend wrapperStyle={{
              paddingTop: '40px'
            }} data-id="element-3210" />
              <Area type="monotone" dataKey="fatturato" stroke="#2D1B69" fillOpacity={1} fill="url(#colorFatturato)" name="Fatturato (€)" data-id="element-3211" />
              <Area type="monotone" dataKey="proformato" stroke="#3B82F6" fillOpacity={1} fill="url(#colorProformato)" name="Proformato (€)" data-id="element-3212" />
              <Area type="monotone" dataKey="target" stroke="#94A3B8" strokeDasharray="5 5" fill="none" name="Target (€)" data-id="element-3213" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </Card>

      {/* Breakdown Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-3214">
        <Card title="Analisi incassi" noHoverShadow data-id="element-3215">
          <div className="space-y-6" data-id="element-3216">
            <div data-id="element-3217">
              <div className="flex justify-between mb-1" data-id="element-3218">
                <span className="text-sm font-medium text-slate-700" data-id="element-3219">
                  Incassato (70%)
                </span>
                <span className="text-sm font-medium text-slate-700" data-id="element-3220">
                  € 41.300
                </span>
              </div>
              <div className="w-full bg-slate-200 rounded-full h-2.5" data-id="element-3221">
                <div className="bg-green-600 h-2.5 rounded-full" style={{
                width: '70%'
              }} data-id="element-3222"></div>
              </div>
            </div>
            <div data-id="element-3223">
              <div className="flex justify-between mb-1" data-id="element-3224">
                <span className="text-sm font-medium text-slate-700" data-id="element-3225">
                  In scadenza (20%)
                </span>
                <span className="text-sm font-medium text-slate-700" data-id="element-3226">
                  € 11.800
                </span>
              </div>
              <div className="w-full bg-slate-200 rounded-full h-2.5" data-id="element-3227">
                <div className="bg-yellow-400 h-2.5 rounded-full" style={{
                width: '20%'
              }} data-id="element-3228"></div>
              </div>
            </div>
            <div data-id="element-3229">
              <div className="flex justify-between mb-1" data-id="element-3230">
                <span className="text-sm font-medium text-slate-700" data-id="element-3231">
                  Scaduto (10%)
                </span>
                <span className="text-sm font-medium text-slate-700" data-id="element-3232">
                  € 5.900
                </span>
              </div>
              <div className="w-full bg-slate-200 rounded-full h-2.5" data-id="element-3233">
                <div className="bg-red-500 h-2.5 rounded-full" style={{
                width: '10%'
              }} data-id="element-3234"></div>
              </div>
            </div>
          </div>
          <div className="mt-6 pt-6 border-t border-slate-100 flex justify-end" data-id="element-3235">
            <Button variant="light" color="primary" onClick={() => navigate('/invoicing')} data-id="element-3236">
              Vedi scadenziario completo
            </Button>
          </div>
        </Card>

        <Card title="Top clienti (fatturato da inizio anno)" noHoverShadow actions={<Button variant="light" size="sm" onClick={() => setShowTopClientsModal(true)} data-id="element-3238">
              Vedi tutti
            </Button>} data-id="element-3237">
          <div className="overflow-x-auto" data-id="element-3239">
            <table className="w-full text-left" data-id="element-3240">
              <thead data-id="element-3241">
                <tr className="text-xs text-slate-500 uppercase border-b border-slate-100" data-id="element-3242">
                  <th className="pb-3 font-semibold" data-id="element-3243">Cliente</th>
                  <th className="pb-3 font-semibold text-right" data-id="element-3244">Fatturato</th>
                  <th className="pb-3 font-semibold text-right" data-id="element-3245">% Totale</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50" data-id="element-3246">
                {topClientsData.slice(0, 5).map((client, i) => <tr key={i} data-id="element-3247">
                    <td className="py-3 text-sm font-medium text-seform-navy" data-id="element-3248">
                      {client.name}
                    </td>
                    <td className="py-3 text-sm text-right text-slate-600" data-id="element-3249">
                      {client.amount}
                    </td>
                    <td className="py-3 text-sm text-right text-slate-500" data-id="element-3250">
                      {client.perc}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </>;
  const renderObiettivi = () => <>
      {/* Period Filter */}
      <div className="flex flex-wrap gap-3 items-end mb-8" data-id="element-3251">
        <div className="w-40" data-id="element-3252">
          <Select options={[{
          value: 'month',
          label: 'Mese corrente'
        }, {
          value: 'year',
          label: 'Anno corrente'
        }, {
          value: 'custom',
          label: 'Personalizzato'
        }]} value={period} onChange={e => setPeriod(e.target.value)} data-id="element-3253" />
        </div>
        {period === 'custom' && <div className="flex gap-2" data-id="element-3254">
            <DatePicker value={customStart} onChange={e => setCustomStart(e.target.value)} data-id="element-3255" />
            <DatePicker value={customEnd} onChange={e => setCustomEnd(e.target.value)} data-id="element-3256" />
          </div>}
        <Button variant="flat" color="secondary" startContent={<Download className="h-4 w-4" data-id="element-3258" />} data-id="element-3257">
          Esporta
        </Button>
        <Button onClick={() => setShowObjectivesModal(true)} startContent={<Plus className="h-4 w-4" data-id="element-3260" />} data-id="element-3259">
          Imposta obiettivi
        </Button>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-3261">
        <Card title="Preventivi positivi da inizio anno" noHoverShadow data-id="element-3262">
          <div className="flex items-end justify-between" data-id="element-3263">
            <div className="min-w-0 flex-1" data-id="element-3264">
              <p className="text-3xl font-bold text-seform-navy truncate" data-id="element-3265">
                € 82.800
              </p>
              <p className="text-sm text-slate-500 mt-1" data-id="element-3266">Target: € 74.000</p>
            </div>
            <div className="text-right flex-shrink-0 ml-4" data-id="element-3267">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-3268">
                +11.9%
              </span>
            </div>
          </div>
          <div className="w-full bg-slate-100 rounded-full h-2 mt-4 overflow-hidden" data-id="element-3269">
            <div className="bg-seform-orange h-2 rounded-full" style={{
            width: '100%'
          }} data-id="element-3270"></div>
          </div>
        </Card>
        <Card title="Fatturato da inizio anno" noHoverShadow data-id="element-3271">
          <div className="flex items-end justify-between" data-id="element-3272">
            <div className="min-w-0 flex-1" data-id="element-3273">
              <p className="text-3xl font-bold text-seform-navy truncate" data-id="element-3274">
                € 272.200
              </p>
              <p className="text-sm text-slate-500 mt-1" data-id="element-3275">Target: € 270.000</p>
            </div>
            <div className="text-right flex-shrink-0 ml-4" data-id="element-3276">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-3277">
                +0.8%
              </span>
            </div>
          </div>
          <div className="w-full bg-slate-100 rounded-full h-2 mt-4 overflow-hidden" data-id="element-3278">
            <div className="bg-seform-navy h-2 rounded-full" style={{
            width: '100%'
          }} data-id="element-3279"></div>
          </div>
        </Card>
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8" data-id="element-3280">
        <Card title="Preventivi: target vs reale" noHoverShadow data-id="element-3281">
          <div className="h-[300px] w-full mt-6" data-id="element-3282">
            <ResponsiveContainer width="100%" height="100%" data-id="element-3283">
              <ComposedChart data={objectivesData} data-id="element-3284">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-3285" />
                <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} dy={10} data-id="element-3286" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} data-id="element-3287" />
                <Tooltip data-id="element-3288" />
                <Legend wrapperStyle={{
                paddingTop: '20px'
              }} data-id="element-3289" />
                <Bar dataKey="actualSales" fill="#FF9500" name="Reale" barSize={20} radius={[4, 4, 0, 0]} data-id="element-3290" />
                <Line type="monotone" dataKey="targetSales" stroke="#94A3B8" strokeWidth={2} dot={false} name="Target" data-id="element-3291" />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </Card>
        <Card title="Fatturato: target vs reale" noHoverShadow data-id="element-3292">
          <div className="h-[300px] w-full mt-6" data-id="element-3293">
            <ResponsiveContainer width="100%" height="100%" data-id="element-3294">
              <ComposedChart data={objectivesData} data-id="element-3295">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-3296" />
                <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} dy={10} data-id="element-3297" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} data-id="element-3298" />
                <Tooltip data-id="element-3299" />
                <Legend wrapperStyle={{
                paddingTop: '20px'
              }} data-id="element-3300" />
                <Bar dataKey="actualRevenue" fill="#2D1B69" name="Reale" barSize={20} radius={[4, 4, 0, 0]} data-id="element-3301" />
                <Line type="monotone" dataKey="targetRevenue" stroke="#94A3B8" strokeWidth={2} dot={false} name="Target" data-id="element-3302" />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>

      {/* Data Table */}
      <Card noPadding className="overflow-hidden" noHoverShadow data-id="element-3303">
        <div className="p-4 flex justify-end border-b border-slate-100" data-id="element-3304">
          <ColumnCustomizer columns={columnsConfig} visibleColumns={visibleColumns} onColumnChange={setVisibleColumns} pageKey="objectives" lockedColumns={['month']} data-id="element-3305" />
        </div>
        <div className="overflow-x-auto" data-id="element-3306">
          <table className="w-full text-left border-collapse" data-id="element-3307">
            <thead data-id="element-3308">
              <tr className="bg-slate-50/50 border-b border-slate-100 text-xs uppercase tracking-wider text-slate-500 font-semibold" data-id="element-3309">
                {columnsConfig.filter(c => visibleColumns.includes(c.key)).map(col => <th key={col.key} className="px-6 py-4 whitespace-pre-line align-top" data-id="element-3310">
                      {col.label}
                    </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-3311">
              {objectivesData.map(item => {
              const diffSales = item.actualSales - item.targetSales;
              const diffRevenue = item.actualRevenue - item.targetRevenue;
              return <tr key={item.id} className="hover:bg-slate-50/80 transition-colors" data-id="element-3312">
                    {visibleColumns.includes('month') && <td className="px-6 py-4 font-medium text-slate-900" data-id="element-3313">
                        {item.month}
                      </td>}
                    {visibleColumns.includes('targetSales') && <td className="px-6 py-4 text-sm text-slate-600" data-id="element-3314">
                        {formatCurrency(item.targetSales)}
                      </td>}
                    {visibleColumns.includes('actualSales') && <td className="px-6 py-4 text-sm font-bold text-seform-navy" data-id="element-3315">
                        {formatCurrency(item.actualSales)}
                      </td>}
                    {visibleColumns.includes('diffSales') && <td className={`px-6 py-4 text-sm font-medium ${diffSales >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-3316">
                        {diffSales >= 0 ? '+' : ''}
                        {formatCurrency(diffSales)}
                      </td>}
                    {visibleColumns.includes('targetRevenue') && <td className="px-6 py-4 text-sm text-slate-600" data-id="element-3317">
                        {formatCurrency(item.targetRevenue)}
                      </td>}
                    {visibleColumns.includes('actualRevenue') && <td className="px-6 py-4 text-sm font-bold text-seform-navy" data-id="element-3318">
                        {formatCurrency(item.actualRevenue)}
                      </td>}
                    {visibleColumns.includes('diffRevenue') && <td className={`px-6 py-4 text-sm font-medium ${diffRevenue >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-3319">
                        {diffRevenue >= 0 ? '+' : ''}
                        {formatCurrency(diffRevenue)}
                      </td>}
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
      </Card>
    </>;
  return <Layout data-id="element-3320">
      {/* Header */}
      <div className="mb-8 flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4" data-id="element-3321">
        <div data-id="element-3322">
          <h1 className="text-3xl font-bold text-seform-navy" data-id="element-3323">Dashboard</h1>
          <p className="text-slate-500 mt-1" data-id="element-3324">Benvenuto, {userName}.</p>
        </div>
        <div className="flex gap-2" data-id="element-3325">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 text-slate-600 rounded-xl text-sm font-medium" data-id="element-3326">
            <Calendar className="h-4 w-4" data-id="element-3327" />
            Oggi: 12 maggio
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="mb-8" data-id="element-3328">
        <div className="border-b border-slate-200" data-id="element-3329">
          <nav className="-mb-px flex space-x-8" data-id="element-3330">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === tab.id ? 'border-seform-orange text-seform-orange' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-700'}`} data-id="element-3331">
                {tab.label}
              </button>)}
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div className="transition-opacity duration-200" data-id="element-3332">
        {activeTab === 'operativa' && renderOperativa()}
        {activeTab === 'commerciale' && renderCommerciale()}
        {activeTab === 'economica' && renderEconomica()}
        {activeTab === 'obiettivi' && renderObiettivi()}
      </div>

      {/* Activities Modal */}
      <Modal isOpen={showActivitiesModal} onClose={() => setShowActivitiesModal(false)} title="Tutte le attività recenti" size="lg" data-id="element-3333">
        <div className="space-y-4 max-h-[60vh] overflow-y-auto" data-id="element-3334">
          {allActivities.map((activity, idx) => <div key={idx} className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg" data-id="element-3335">
              <span className={`h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0 ${activity.bg}`} data-id="element-3336">
                <activity.icon className={`h-4 w-4 ${activity.text}`} data-id="element-3337" />
              </span>
              <div className="flex-1 min-w-0" data-id="element-3338">
                <p className="text-sm text-slate-600" data-id="element-3339">
                  <span className="font-semibold text-seform-navy" data-id="element-3340">
                    {activity.user}
                  </span>{' '}
                  {activity.action}{' '}
                  <span className="font-semibold text-seform-navy" data-id="element-3341">
                    {activity.target}
                  </span>
                </p>
                <p className="text-xs text-slate-400 mt-1" data-id="element-3342">{activity.date}</p>
              </div>
            </div>)}
        </div>
      </Modal>

      {/* Top Clients Modal */}
      <Modal isOpen={showTopClientsModal} onClose={() => setShowTopClientsModal(false)} title="Top clienti (fatturato da inizio anno)" size="lg" data-id="element-3343">
        <div className="overflow-x-auto max-h-[60vh]" data-id="element-3344">
          <table className="w-full text-left" data-id="element-3345">
            <thead className="sticky top-0 bg-white" data-id="element-3346">
              <tr className="text-xs text-slate-500 uppercase border-b border-slate-100" data-id="element-3347">
                <th className="pb-3 font-semibold" data-id="element-3348">#</th>
                <th className="pb-3 font-semibold" data-id="element-3349">Cliente</th>
                <th className="pb-3 font-semibold text-right" data-id="element-3350">Fatturato</th>
                <th className="pb-3 font-semibold text-right" data-id="element-3351">% Totale</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-3352">
              {topClientsData.map((client, i) => <tr key={i} className="hover:bg-slate-50" data-id="element-3353">
                  <td className="py-3 text-sm text-slate-400" data-id="element-3354">{i + 1}</td>
                  <td className="py-3 text-sm font-medium text-seform-navy" data-id="element-3355">
                    {client.name}
                  </td>
                  <td className="py-3 text-sm text-right text-slate-600" data-id="element-3356">
                    {client.amount}
                  </td>
                  <td className="py-3 text-sm text-right text-slate-500" data-id="element-3357">
                    {client.perc}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Modal>

      {/* Objectives Modal */}
      <Modal isOpen={showObjectivesModal} onClose={() => setShowObjectivesModal(false)} title="Imposta obiettivi" size="lg" data-id="element-3358">
        <div className="space-y-6" data-id="element-3359">
          {/* Monthly / Annual Toggle */}
          <div className="bg-slate-100 p-1 rounded-xl flex items-center w-fit mx-auto" data-id="element-3360">
            <button onClick={() => setObjectivePeriodType('monthly')} className={`px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${objectivePeriodType === 'monthly' ? 'bg-white text-seform-navy shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-3361">
              Obiettivi mensili
            </button>
            <button onClick={() => setObjectivePeriodType('annual')} className={`px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${objectivePeriodType === 'annual' ? 'bg-white text-seform-navy shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-3362">
              Obiettivi annuali
            </button>
          </div>

          <section data-id="element-3363">
            <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-3364">
              <Target className="h-4 w-4" data-id="element-3365" />{' '}
              {objectivePeriodType === 'monthly' ? 'Dettaglio Mensile' : 'Dettaglio Annuale'}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3366">
              {objectivePeriodType === 'monthly' ? <Input label="Mese" type="month" className="col-span-full" data-id="element-3367" /> : <Select label="Anno" className="col-span-full" options={[{
              value: '2024',
              label: '2024'
            }, {
              value: '2025',
              label: '2025'
            }, {
              value: '2026',
              label: '2026'
            }, {
              value: '2027',
              label: '2027'
            }, {
              value: '2028',
              label: '2028'
            }, {
              value: '2029',
              label: '2029'
            }, {
              value: '2030',
              label: '2030'
            }]} data-id="element-3368" />}

              <Input label="Obiettivo preventivi (€)" type="number" data-id="element-3369" />
              <Input label="Obiettivo fatturato (€)" type="number" data-id="element-3370" />
              <Input label="Importo + fatturato (€)" type="number" data-id="element-3371" />
              <Input label="Importo di fatturato (€)" type="number" data-id="element-3372" />
              <Input label="% da incassare rispetto al fatturato + proformato" type="number" endContent={<span className="text-slate-500 font-medium" data-id="element-3374">%</span>} className="col-span-full" data-id="element-3373" />
            </div>
          </section>
          <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-3375">
            <Button variant="flat" color="default" onClick={() => setShowObjectivesModal(false)} data-id="element-3376">
              Annulla
            </Button>
            <Button onClick={() => setShowObjectivesModal(false)} data-id="element-3377">Salva</Button>
          </div>
        </div>
      </Modal>

      {/* Deadline View Modal */}
      <Modal isOpen={showDeadlineViewModal} onClose={() => setShowDeadlineViewModal(false)} title="Dettaglio scadenza" size="md" data-id="element-3378">
        {selectedDeadline && <div className="space-y-6" data-id="element-3379">
            <div className="grid grid-cols-2 gap-4" data-id="element-3380">
              <div data-id="element-3381">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-3382">
                  Titolo
                </span>
                <p className="font-medium" data-id="element-3383">{selectedDeadline.title}</p>
              </div>
              <div data-id="element-3384">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-3385">
                  Priorità
                </span>
                <div className="mt-1" data-id="element-3386">
                  <Badge variant={selectedDeadline.priority === 'high' ? 'danger' : selectedDeadline.priority === 'medium' ? 'warning' : 'info'} data-id="element-3387">
                    {selectedDeadline.priority === 'high' ? 'Alta' : selectedDeadline.priority === 'medium' ? 'Media' : 'Bassa'}
                  </Badge>
                </div>
              </div>
              <div data-id="element-3388">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-3389">
                  Cliente
                </span>
                <p className="font-medium" data-id="element-3390">{selectedDeadline.client}</p>
              </div>
              <div data-id="element-3391">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-3392">
                  Data
                </span>
                <p className="font-medium" data-id="element-3393">{selectedDeadline.date}</p>
              </div>
            </div>
            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-3394">
              <Button variant="flat" color="default" onClick={() => setShowDeadlineViewModal(false)} data-id="element-3395">
                Chiudi
              </Button>
              <Button onClick={() => {
            setShowDeadlineViewModal(false);
            setShowDeadlineEditModal(true);
          }} startContent={<Edit className="h-4 w-4" data-id="element-3397" />} data-id="element-3396">
                Modifica
              </Button>
            </div>
          </div>}
      </Modal>

      {/* Deadline Edit Modal */}
      <Modal isOpen={showDeadlineEditModal} onClose={() => setShowDeadlineEditModal(false)} title="Modifica scadenza" size="md" data-id="element-3398">
        {selectedDeadline && <div className="space-y-6" data-id="element-3399">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3400">
              <Input label="Titolo" defaultValue={selectedDeadline.title} required data-id="element-3401" />
              <Input label="Cliente" defaultValue={selectedDeadline.client} required data-id="element-3402" />
              <Input label="Data" type="date" required data-id="element-3403" />
              <Select label="Priorità" defaultValue={selectedDeadline.priority} options={[{
            value: 'high',
            label: 'Alta'
          }, {
            value: 'medium',
            label: 'Media'
          }, {
            value: 'low',
            label: 'Bassa'
          }]} required data-id="element-3404" />
            </div>
            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-3405">
              <Button variant="flat" color="default" onClick={() => setShowDeadlineEditModal(false)} data-id="element-3406">
                Annulla
              </Button>
              <Button onClick={() => setShowDeadlineEditModal(false)} data-id="element-3407">
                Salva
              </Button>
            </div>
          </div>}
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteConfirm} onClose={() => setShowDeleteConfirm(false)} title="Conferma eliminazione" size="sm" data-id="element-3408">
        <div className="space-y-6" data-id="element-3409">
          <div className="bg-red-50 p-4 rounded-lg border border-red-100 flex gap-3" data-id="element-3410">
            <AlertCircle className="h-5 w-5 text-red-600 flex-shrink-0" data-id="element-3411" />
            <p className="text-sm text-red-700" data-id="element-3412">
              Attenzione: questa azione è irreversibile. La scadenza verrà
              eliminata definitivamente.
            </p>
          </div>
          <div className="flex justify-end gap-3 pt-4" data-id="element-3413">
            <Button variant="flat" color="default" onClick={() => setShowDeleteConfirm(false)} data-id="element-3414">
              Annulla
            </Button>
            <Button color="danger" onClick={() => setShowDeleteConfirm(false)} data-id="element-3415">
              Elimina
            </Button>
          </div>
        </div>
      </Modal>

      {/* Activity Detail Modal */}
      <ActivityDetailModal isOpen={showActivityDetail} onClose={() => setShowActivityDetail(false)} activity={selectedActivity} onEdit={handleEditActivity} onStepComplete={handleStepComplete} data-id="element-3416" />
    </Layout>;
}